<template>
  <svg class="rem-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.2">
      <rect opacity="0.2" width="40" height="40" rx="4" fill="#00527F"/>
      <path d="M28.1063 16.85L27.3313 31.3C27.3063 31.825 26.8563 32.25 26.3313 32.25H13.6563C13.1313 32.25 12.6813 31.825 12.6563 31.3L11.8813 16.85C11.8563 16.3 12.2813 15.825 12.8313 15.8C13.3813 15.775 13.8563 16.2 13.8813 16.75L14.6063 30.25H25.3813L26.1063 16.75C26.1313 16.2 26.6063 15.775 27.1563 15.8C27.7063 15.825 28.1313 16.3 28.1063 16.85ZM30.7563 13.5C30.7563 14.05 30.3063 14.5 29.7563 14.5H10.2563C9.70629 14.5 9.25629 14.05 9.25629 13.5C9.25629 12.95 9.70629 12.5 10.2563 12.5H15.7563V10.25C15.7563 9.775 16.0813 9.5 16.5563 9.5H23.4563C23.9313 9.5 24.2563 9.775 24.2563 10.25V12.5H29.7563C30.3063 12.5 30.7563 12.95 30.7563 13.5ZM17.5063 12.5H22.5063V11.25H17.5063V12.5ZM17.9313 28.75C18.4313 28.75 18.8063 28.275 18.8063 27.8L18.5563 17C18.5563 16.525 18.1563 16.125 17.6563 16.125C17.1813 16.125 16.7813 16.525 16.8063 17.025L17.0563 27.85C17.0563 28.325 17.4563 28.75 17.9313 28.75ZM22.0563 28.75C22.5313 28.75 22.9313 28.35 22.9313 27.875L23.1813 17.075C23.1813 16.6 22.8063 16.175 22.3313 16.175C21.8313 16.175 21.4563 16.55 21.4313 17.025L21.1813 27.825C21.1563 28.325 21.5563 28.75 22.0563 28.75C22.0313 28.75 22.0313 28.75 22.0563 28.75Z" fill="#00527F"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'remBtn'
  }
</script>

<style lang="scss" scoped>
  .rem-btn {
    margin-left: 30px;
    float: left;
    cursor: pointer;

    &:hover path {
      fill: #000000;
    }
  }
</style>
